module.exports = __webpack_public_path__ + "static/media/arrows.809cda1a.svg";